// constants/companyConfig.js
const COMPANIES = {
  PRTC: {
    name: 'PRTC',
    fullName: 'Palmetto Rural Telephone Cooperative',
    domain: 'prtc',
    apiCustomerId: 'PRTC',
    customerName: 'PRTC',
    clientName: 'prtc',
    companyId: 255,
    customerId: '123',
    clientId: '123',
    themeId: 255,
    accountOrgName: 'PRTC',
    paymentAvailable: true,
    // signInUrl: (env) =>
    //   `https://${env}-prtc.subscriberconnect.cdgportal.com/Login`,
   signInUrl: (env) =>
    env === 'prod'
    ? 'https://prtc.subscriberconnect.cdgportal.com/Login'
    : `https://${env}-prtc.subscriberconnect.cdgportal.com/Login`,
    termsUrl: null, // Fetch from API
    support: {
      phoneNumber: '(803) 538-5481',
      url: 'https://www.prtc.us/support',
    },
    ui: {
      addressForm: {
        type: 'simple',
        iconType: 'png', // Use PNG icons for PRTC
        icons: {
          residential: '/images/icons/Residential.png',
          residentialActive: '/images/icons/Residential-active.png',
          business: '/images/icons/Business.png',
          businessActive: '/images/icons/Business-active.png',
        },
      },
      gardenwallhomepageImage: '../assets/icons/homepage.png',
    },
    features: {
      showGreatNewsOnFirstClick: true, // PRTC shows "Great News!" immediately when address is selected
      requireDoubleClickForAddress: false, // PRTC uses single-click behavior
    },
  },
  ARCHTOP: {
    name: 'Archtop Fiber',
    fullName: 'Archtop Fiber',
    domain: 'archtop',
    apiCustomerId: 'archtop fiber',
    customerName: 'archtop fiber',
    clientName: 'archtop',
    companyId: 256,
    customerId: 'a989935c-0575-423b-980e-dd9bc90a87de',
    clientId: 'a989935c-0575-423b-980e-dd9bc90a87de',
    themeId: 256,
    accountOrgName: 'Archtop',
    paymentAvailable: false,
    signInUrl: (env) =>
      `https://${env}-archtop.subscriberconnect.cdgportal.com/Login`,
    termsUrl: null, // Fetch from API
    support: {
      phoneNumber: '(803) 538-5481', // Update with Archtop's actual support number
      url: 'https://www.archtopfiber.com/support', // Update with Archtop's actual support URL
    },
    ui: {
      addressForm: {
        type: 'detailed',
        iconType: 'png', // Use PNG icons for Archtop
        icons: {
          residential: '/images/icons/Residential.png',
          residentialActive: '/images/icons/Residential-active-archtop.png',
          business: '/images/icons/Business.png',
          businessActive: '/images/icons/Business-active-archtop.png',
        },
      },
      gardenwallhomepageImage: '../assets/icons/homepage-archtop.png',
    },
    features: {
      showGreatNewsOnFirstClick: false, // ARCHTOP shows "Great News!" only after first Next click
      requireDoubleClickForAddress: true, // ARCHTOP uses double-click behavior
    },
  },
  INTERBEL: {
    name: 'Interbel',
    fullName: 'Interbel',
    domain: 'interbel',
    apiCustomerId: 'PRTC',
    customerName: 'PRTC',
    clientName: 'prtc',
    companyId: 255, // Use PRTC's company ID for API calls
    themeId: 257, // Use separate theme ID for styling
    accountOrgName: 'Interbel',
    paymentAvailable: true, // Uses PRTC payment gateway
    // signInUrl: (env) =>
    //   `https://${env}-interbel.subscriberconnect.cdgportal.com/Login`,
    signInUrl: (env) => `https://interbel.cdg.iinerds.com/Login`,
    termsUrl: 'https://interbel.com/acceptable-use-policy/',
    support: {
      phoneNumber: '(803) 538-5481', // Update with Interbel's actual support number
      url: 'https://www.interbel.com/support', // Update with Interbel's actual support URL
    },
    ui: {
      addressForm: {
        type: 'simple',
        iconType: 'png', // Use PNG icons for Interbel
        icons: {
          residential: '/images/icons/Residential.png',
          residentialActive: '/images/icons/Residential-active-interbel.png',
          business: '/images/icons/Business.png',
          businessActive: '/images/icons/Business-active-interbel.png',
        },
      },
      gardenwallhomepageImage: '../assets/icons/homepage.png',
    },
    features: {
      showGreatNewsOnFirstClick: true, // Interbel shows "Great News!" immediately when address is selected
      requireDoubleClickForAddress: false, // Interbel uses single-click behavior
    },
  },

  HIGHLINE: {
    name: 'Highline',
    fullName: 'Highline',
    domain: 'highline',
    apiCustomerId: 'HIGHLINE',
    customerName: 'HIGHLINE',
    clientName: 'highline',
    companyId: 255,
    themeId: 258,
    accountOrgName: 'Highline',
    paymentAvailable: true,
    // signInUrl: (env) =>
    //   `https://${env}-highline.subscriberconnect.cdgportal.com/Login`,
    signInUrl: (env) => `https://highline.cdg.iinerds.com/Login`,
    termsUrl: '/pdf/Terms%20and%20Conditions%20High%20Line.pdf',
    support: {
      phoneNumber: '(803) 538-5481', // Update with Highline's actual support number
      url: 'https://www.highline.com/support', // Update with Highline's actual support URL
    },
    ui: {
      addressForm: {
        type: 'simple',
        iconType: 'png', // Use PNG icons for Highline
        icons: {
          residential: '/images/icons/Residential.png',
          residentialActive: '/images/icons/Residential-active-highline.png',
          business: '/images/icons/Business.png',
          businessActive: '/images/icons/Business-active-highline.png',
        },
      },
      gardenwallhomepageImage: '../assets/icons/homepage-highline.png',
      // Custom node UI configurations for Highline
      nodes: {
        // Example: customize specific workflow nodes
        customStyles: {
          // You can define custom styles for specific node types
          'node-type-1': {
            backgroundColor: '#custom-color',
            borderColor: '#custom-border',
            textColor: '#custom-text',
          },
          'node-type-2': {
            backgroundColor: '#another-color',
            borderColor: '#another-border',
            textColor: '#another-text',
          },
        },
        // Hide/show specific nodes
        hiddenNodes: [
          // 'node-id-to-hide-1',
          // 'node-id-to-hide-2',
        ],
        // Custom node labels/text
        customLabels: {
          // 'original-node-id': 'Custom Label for Highline',
          // 'another-node-id': 'Another Custom Label',
        },
        // Custom node behaviors
        customBehaviors: {
          // 'node-id': { skipValidation: true, autoAdvance: false },
        },
      },
    },
    features: {
      showGreatNewsOnFirstClick: true, // Highline shows "Great News!" immediately when address is selected
      requireDoubleClickForAddress: false, // Highline uses single-click behavior
      customNodeHandling: true, // Flag to enable custom node handling for Highline
    },
  },

  ACS: {
    name: 'ACS',
    fullName: 'Alaska Communications',
    domain: 'acs',
    apiCustomerId: 'PRTC',
    customerName: 'PRTC',
    clientName: 'acs',
    companyId: 255, // Use PRTC's company ID for API calls
    themeId: 259, // Use separate theme ID for styling
    accountOrgName: 'ACS',
    paymentAvailable: true, // Uses PRTC payment gateway
    signInUrl: (env) => `https://acs.cdg.iinerds.com/Login`,
    termsUrl: '/pdf/Terms%20and%20Conditions%20ACS.pdf',
    //termsUrl: ' https://www.alaskacommunications.com/Terms-and-Conditions',
    support: {
      phoneNumber: '(803) 538-5481', // Update with ACS's actual support number
      url: 'https://www.alaskacommunications.com/support', // Update with ACS's actual support URL
    },
    ui: {
      addressForm: {
        type: 'simple',
        iconType: 'png', // Use PNG icons for ACS
        icons: {
          residential: '/images/icons/Residential.png',
          residentialActive: '/images/icons/Residential-active-acs.png',
          business: '/images/icons/Business.png',
          businessActive: '/images/icons/Business-active-acs.png',
        },
      },
      gardenwallhomepageImage: '../assets/icons/homepage-acs.png',
    },
    features: {
      showGreatNewsOnFirstClick: true, // ACS shows "Great News!" immediately when address is selected
      requireDoubleClickForAddress: false, // ACS uses single-click behavior
      customNodeHandling: false, // ACS uses default AddOns component (card-based UI)
    },
  },

  CWF: {
    name: 'CWF',
    fullName: 'clear wave Fiber',
    domain: 'cwf',
    apiCustomerId: 'clearwave fiber',
    customerName: 'clearwave fiber',
    clientName: 'cwf',
    companyId: 255,
    themeId: 260,
    accountOrgName: 'CWF',
    paymentAvailable: false,
    //  signInUrl: (env) => `https://cwf.subscriberconnect.cdgportal.com/Login`,
    signInUrl: (env) =>
      `https://${env}-cwf.subscriberconnect.cdgportal.com/Login`,
    termsUrl: 'https://www.clearwavefiber.com/legal/terms-and-conditions/',
    support: {
      phoneNumber: '(803) 538-5481', // Update with CWF's actual support number
      url: 'https://www.cwf.com/support', // Update with CWF's actual support URL
    },
    ui: {
      addressForm: {
        type: 'simple',
        iconType: 'png', // Use PNG icons for CWF
        icons: {
          residential: '/images/icons/Residential.png',
          residentialActive: '/images/icons/Residential-active-cwf.png',
          business: '/images/icons/Business.png',
          businessActive: '/images/icons/Business-active-cwf.png',
        },
      },
      gardenwallhomepageImage: '../assets/icons/homepage-cwf.png',
    },
    features: {
      showGreatNewsOnFirstClick: true, // CWF shows "Great News!" immediately when address is selected
      requireDoubleClickForAddress: false, // CWF uses single-click behavior
      customNodeHandling: false, // Flag to enable custom node handling for CWF
    },
  },
};

export const getCurrentCompany = () => {
  // PRIORITY 1: Check environment variable first (for local development)
  const envCompany = process.env.REACT_APP_COMPANY;
   
  if (envCompany) {
    const normalizedEnvCompany = envCompany.toLowerCase().trim();

    console.log('🔍 Company Detection - ENV Variable:', envCompany);

    // Check for exact matches or partial matches
    if (
      normalizedEnvCompany === 'archtop' ||
      normalizedEnvCompany.includes('archtop')
    ) {
      console.log('✅ Company Detected: ARCHTOP (from ENV)');
      return COMPANIES.ARCHTOP;
    }

    if (
      normalizedEnvCompany === 'interbel' ||
      normalizedEnvCompany.includes('interbel')
    ) {
      console.log('✅ Company Detected: INTERBEL (from ENV)');
      return COMPANIES.INTERBEL;
    }

    if (
      normalizedEnvCompany === 'prtc' ||
      normalizedEnvCompany.includes('prtc')
    ) {
      console.log('✅ Company Detected: PRTC (from ENV)');
      return COMPANIES.PRTC;
    }

    if (
      normalizedEnvCompany === 'highline' ||
      normalizedEnvCompany.includes('highline')
    ) {
      console.log('✅ Company Detected: HIGHLINE (from ENV)');
      return COMPANIES.HIGHLINE;
    }

    if (
      normalizedEnvCompany === 'acs' ||
      normalizedEnvCompany.includes('acs')
    ) {
      console.log('✅ Company Detected: ACS (from ENV)');
      return COMPANIES.ACS;
    }

    if (
      normalizedEnvCompany === 'cwf' ||
      normalizedEnvCompany.includes('cwf')
    ) {
      console.log('✅ Company Detected: CWF (from ENV)');
      return COMPANIES.CWF;
    }

    // Fallback: try to find by name
    const company = Object.values(COMPANIES).find(
      (c) => c.name.toLowerCase() === normalizedEnvCompany
    );
    if (company) {
      console.log(
        `✅ Company Detected: ${company.name} (from ENV - name match)`
      );
      return company;
    }
  }

  // PRIORITY 2: Check URL parameters (for iframe scenarios)
  const urlParams = new URLSearchParams(window.location.search);
  const companyParam = urlParams.get('company');
  if (companyParam) {
    const normalizedParam = companyParam.toLowerCase();
    console.log('🔍 Company Detection - URL Param:', companyParam);

    if (normalizedParam.includes('archtop')) {
      console.log('✅ Company Detected: ARCHTOP (from URL)');
      return COMPANIES.ARCHTOP;
    }
    if (normalizedParam.includes('interbel')) {
      console.log('✅ Company Detected: INTERBEL (from URL)');
      return COMPANIES.INTERBEL;
    }
    if (normalizedParam.includes('prtc')) {
      console.log('✅ Company Detected: PRTC (from URL)');
      return COMPANIES.PRTC;
    }
    if (normalizedParam.includes('highline')) {
      console.log('✅ Company Detected: HIGHLINE (from URL)');
      return COMPANIES.HIGHLINE;
    }
    if (normalizedParam.includes('acs')) {
      console.log('✅ Company Detected: ACS (from URL)');
      return COMPANIES.ACS;
    }
    if (normalizedParam.includes('cwf')) {
      console.log('✅ Company Detected: CWF (from URL)');
      return COMPANIES.CWF;
    }
  }

  // PRIORITY 3: Check hostname
  let hostname = window.location.hostname;
  console.log('🔍 Company Detection - Hostname:', hostname);

  // If in iframe, try to get parent hostname
  try {
    if (window.self !== window.top && window.parent) {
      hostname = window.parent.location.hostname;
      console.log('🔍 Company Detection - Parent Hostname:', hostname);
    }
  } catch (e) {
    // Cross-origin iframe - can't access parent hostname
    console.log('⚠️ Cannot access parent hostname (cross-origin)');
  }

  // Check hostname for company detection
  if (hostname.includes('archtop')) {
    console.log('✅ Company Detected: ARCHTOP (from hostname)');
    return COMPANIES.ARCHTOP;
  }

  if (hostname.includes('interbel')) {
    console.log('✅ Company Detected: INTERBEL (from hostname)');
    return COMPANIES.INTERBEL;
  }

  if (hostname.includes('prtc')) {
    console.log('✅ Company Detected: PRTC (from hostname)');
    return COMPANIES.PRTC;
  }

  if (hostname.includes('highline')) {
    console.log('✅ Company Detected: HIGHLINE (from hostname)');
    return COMPANIES.HIGHLINE;
  }

  if (hostname.includes('acs')) {
    console.log('✅ Company Detected: ACS (from hostname)');
    return COMPANIES.ACS;
  }

  if (hostname.includes('cwf')) {
    console.log('✅ Company Detected: CWF (from hostname)');
    return COMPANIES.CWF;
  }

  // FALLBACK: Default to PRTC
  console.log('⚠️ No company detected - defaulting to PRTC');
  return COMPANIES.PRTC;
};

// Export the current company configuration
export const COMPANY_CONFIG = getCurrentCompany();

// Export individual company properties for backward compatibility
export const COMPANY_NAME = COMPANY_CONFIG.name;
export const COMPANY_FULL_NAME = COMPANY_CONFIG.fullName;
export const COMPANY_API_CUSTOMER_ID = COMPANY_CONFIG.apiCustomerId;
export const CUSTOMER_NAME = COMPANY_CONFIG.customerName;
export const CUSTOMER_ID = COMPANY_CONFIG.customerId;
export const COMAPANY_ID = COMPANY_CONFIG.companyId;
export const CLIENT_ID = COMPANY_CONFIG.clientId;
export const THEME_ID = COMPANY_CONFIG.themeId;
export const CLIENT_NAME = COMPANY_CONFIG.clientName;
export const PAYMENT_AVAILABLE = COMPANY_CONFIG.paymentAvailable;

// Global company check helpers
export const isACS = COMPANY_CONFIG.name === 'ACS';
export const isInterbel = COMPANY_CONFIG.name === 'Interbel';
export const isPRTC = COMPANY_CONFIG.name === 'PRTC';
export const isArchtop = COMPANY_CONFIG.name === 'Archtop Fiber';
export const isHighline = COMPANY_CONFIG.name === 'Highline';
export const isCWF = COMPANY_CONFIG.name === 'CWF';

export default COMPANIES;
